<template>
  <div id="store">
    <div class="doorEditBox">
      <div class="title">{{type}}门店</div>
      <el-form ref="form" :model="form" label-width="160px">
        <el-form-item :label="$t('filters.doorName')">
          <el-input v-model="form.doorName" :placeholder="$t('filters.chooseDoorName')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('store.doorAddress')">
          <el-input v-model="form.doorAddress" :placeholder="$t('filters.enterDoorAddress')"></el-input>
        </el-form-item>
        <el-form-item label="门店编号">
          <el-input v-model="form.posId" :placeholder="$t('filters.choosePOSID')"></el-input>
        </el-form-item>
        <el-form-item label="Store Phase">
          <el-input v-model="form.storePhase" :placeholder="$t('filters.enterStorePhase')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('filters.publicAccountType')">
          <el-select v-model="form.region" :placeholder="$t('filters.choosePublicAccountType')" style="width: 100%" :disabled="isEdit">
            <el-option
              v-for="item in publicAccountTypeOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('filters.publicAccountName')">
          <el-input v-model="form.publicAccountName" :placeholder="$t('filters.enterPublicAccountName')" :disabled="isEdit"></el-input>
        </el-form-item>
        <el-form-item :label="$t('filters.region')" >
          <el-select v-model="form.regionNo" :placeholder="$t('filters.chooseRegion')" @visible-change="resetFilters()" style="width: 100%">
            <el-option
              v-for="item in regionOptions"
              :key="item.itemKey"
              :label="item.itemValue"
              :value="item.itemKey">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('filters.province')" >
          <el-select v-model="form.provinceNo" :placeholder="$t('filters.chooseProvince')" @visible-change="resetFilters()" style="width: 100%">
            <el-option
              v-for="item in provinceOptions"
              :key="item.itemKey"
              :label="item.itemValue"
              :value="item.itemKey">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('filters.city')" >
          <el-select v-model="form.cityNo" :placeholder="$t('filters.chooseCity')" @visible-change="getRangeList()" style="width: 100%">
            <el-option
              v-for="item in cityOptions"
              :key="item.itemKey"
              :label="item.itemValue"
              :value="item.itemKey">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('filters.locate')" >
          <el-select v-model="form.locate" :placeholder="$t('filters.chooseLocate')" @visible-change="getRangeList()" style="width: 100%">
            <el-option
              v-for="item in locateOptions"
              :key="item.itemKey"
              :label="item.itemValue"
              :value="item.itemKey">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('filters.storeType')" >
          <el-select v-model="form.storeType" :placeholder="$t('filters.chooseStoreType')" @visible-change="getRangeList()" style="width: 100%">
            <el-option
              v-for="item in storeTypeOptions"
              :key="item.itemKey"
              :label="item.itemValue"
              :value="item.itemKey">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('filters.reseller')" >
          <el-select v-model="form.resellerNo" multiple :placeholder="$t('filters.chooseReseller')" @visible-change="resetFilters()" style="width: 100%">
            <el-option
              v-for="item in resellerOptions"
              :key="item.itemKey"
              :label="item.itemValue"
              :value="item.itemKey">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('filters.subReseller')" >
          <el-select v-model="form.subReseller" multiple :placeholder="$t('filters.chooseSubReseller')" @visible-change="resetFilters()" style="width: 100%">
            <el-option
              v-for="item in subResellerOptions"
              :key="item.itemKey"
              :label="item.itemValue"
              :value="item.itemKey">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('newSurvey.createTime')" v-if="isEdit">
          {{ form.createTime }}
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">{{ $t('save') }}</el-button>
          <el-button @click="cancel">{{ $t('cancel') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  data() {
    return {
      isEdit: false,
      storeTypeOptions: [],
      locateOptions: [],
      regionOptions: [],
      provinceOptions: [],
      cityOptions: [],
      resellerOptions: [],
      subResellerOptions: [],
      publicAccountTypeOptions: [],
      id: this.$route.query.id || null,
      type: '',
      form: {
        doorName: '',
        doorAddress: '',
        posId: '',
        storePhase: '',
        publicAccountType: '',
        publicAccountName: '',
        regionNo: '',
        provinceNo: '',
        cityNo: '',
        locate: '',
        storeType: '',
        reseller: '',
        subReseller: '',
        createTime: ''
      }
    }
  },
  mounted () {
    this.getRangeList()
    this.type = _.isNil(this.id) ? '新增' : '编辑'
    this.isEdit = !_.isNil(this.id)
  },
  methods: {
    resetFilters: function () {
      this.getRangeList()
    },
    getRangeList: async function (clear) {
      let filterParams = {
        'cityNo': this.form.cityNo,
        'resellerNo': this.form.resellerNo,
        'subReseller': this.form.subReseller,
        'provinceNo': this.form.provinceNo,
        'regionNo': this.form.regionNo,
      }
      let submitParams = this.$tool.formatArrayToString(filterParams)
      if (clear) {
        submitParams = {}
      }
      let res = await window.instance.post(window.retailogUrl + '/account/common', submitParams)
      console.log('res', res)
      res = res.data.data
      this.locateOptions = res.locateList
      this.regionOptions = res.regionList
      this.provinceOptions = res.provinceList
      this.cityOptions = res.cityList
      this.resellerOptions = res.resellerList
      this.subResellerOptions = res.subResellerList
    },
    onSubmit() {
      console.log('submit!');
    },
    cancel() {
      this.$router.push({ path: '/wo/doorEdit', query: { id: row.id }})
    }
  }
}
</script>

<style lang="sass" scoped>
.doorEditBox
  width: 80%
  margin: auto
  .title
    font-size: 16px
    text-align: center
    margin: 20px 0
</style>



// WEBPACK FOOTER //
// src/pages/wo/doorEdit.vue